import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const withdrawalSchema = z.object({
  /** Record ID, e.g. "w56279272" */
  id: z.string(),
  /** Hash record of the withdrawal, e.g. "0x303eedca10adc7ca2b8fe03b43605cf43452f79181966958223b6574842bf328" */
  txid: z.string(),
  /** Operation time, e.g. "1712998802" */
  timestamp: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number(v) * 1000),
  /** Currency amount, e.g. "2.5" */
  amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** fee, e.g. "0.5" */
  fee: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Currency name, e.g. "USDT" */
  currency: z.string(),
  /** Withdrawal address, e.g. "0x6d673456df016fcc401c4cd985846a1725c81a63" */
  address: z.string(),
  /** Additional remarks with regards to the withdrawal */
  memo: z.string().nullable(),
  status: z.union([
    // - DONE: 完成 (block_number > 0 才算真的上链完成)
    z.literal('DONE'),
    // - CANCEL: 已取消
    z.literal('CANCEL'),
    // - REQUEST: 请求中
    z.literal('REQUEST'),
    // - MANUAL: 待人工审核
    z.literal('MANUAL'),
    // - BCODE: 充值码操作
    z.literal('BCODE'),
    // - EXTPEND: 已经发送等待确认
    z.literal('EXTPEND'),
    // - FAIL: 链上失败等待确认
    z.literal('FAIL'),
    // - INVALID: 无效订单
    z.literal('INVALID'),
    // - VERIFY: 验证中
    z.literal('VERIFY'),
    // - PROCES: 处理中
    z.literal('PROCES'),
    // - PEND: 处理中
    z.literal('PEND'),
    // - DMOVE: 待人工审核
    z.literal('DMOVE'),
    // - SPLITPEND: cny提现大于5w,自动分单
    z.literal('SPLITPEND'),
  ]),
  /** Name of the chain used in withdrawals, e.g. "ARBEVM" */
  chain: z.string(),
})

export type Withdrawal = z.infer<typeof withdrawalSchema>
